import React from 'react';
import { useNavigate } from 'react-router-dom';

// material-ui
import {
    Chip,
    Grid,
    IconButton,
    Link,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tooltip,
    Typography
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { useTheme } from '@mui/material/styles';

// project imports
import Avatar from 'ui-component/extended/Avatar';
import DeleteAlert from './DeleteAlert';
import { USER_STATUS } from 'store/constant';
import ColoredDropdown from 'views/User/SimpleSpeedDials';
import useApi from 'hooks/useApi';
import VenueService from 'services/VenueService';

const VenueList = ({ rows, page, limit, setReload, sportsTypes }) => {

    const navigate = useNavigate();
    const theme = useTheme();

    const getSportsType = function (typesString) {
        const splitTypes = typesString.split(',');
        return splitTypes.map(x => {
            let findInd = sportsTypes.findIndex(st => st.code === x);
            return findInd >= 0 ? sportsTypes[findInd].display_name : '';
        }).toString();
    };

    const handleEditVenue = (venueUuid) => {
        navigate(`/venue/edit/${venueUuid}`);
    };

    const handleViewVenue = (venueUuid) => {
        navigate(`/venue/view/${venueUuid}`)
    };

    const changeStatus = (rowuuid) => {
        changeVenueStatusApi.execute(rowuuid);
    };

    const changeStatusHandler = () => {
        setReload(r => !r);
    };

    const changeVenueStatusApi = useApi(VenueService.changeVenueStatusByUuid, changeStatusHandler, true);

    return (
        <TableContainer>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{ pl: 3 }}>#</TableCell>
                        <TableCell>Venue Name</TableCell>
                        <TableCell sx={{ paddingLeft: '70px' }}>Sports Type</TableCell>
                        <TableCell>City</TableCell>
                        <TableCell>Address</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap' }} align="center">Board Available</TableCell>
                        <TableCell>Published</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell align="center" sx={{ pr: 3 }}>
                            Actions
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        rows.map((row, index) => {
                            return (
                                <TableRow hover key={index}>
                                    <TableCell sx={{ pl: 3 }}>{page * limit - limit + index + 1}</TableCell>
                                    <TableCell>
                                        <Grid container spacing={2} alignItems="center">
                                            <Grid item>
                                                <Avatar alt="Venue" src={row.banner_image} />
                                            </Grid>
                                            <Grid item xs zeroMinWidth>
                                                <Typography align="left" variant="subtitle1" component="div">
                                                    <Link underline='hover' onClick={() => handleViewVenue(row.uuid)} sx={{
                                                        cursor: 'pointer'
                                                    }}>{row.venue_name}</Link>
                                                </Typography>
                                                <Typography align="left" variant="subtitle2" noWrap>
                                                    {row.owner_name}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </TableCell>
                                    <TableCell sx={{ paddingLeft: '70px' }}>
                                        {getSportsType(row.sports_type)}
                                    </TableCell>
                                    <TableCell>
                                        <Link href={row.venue_map_link} color="inherit" underline="hover" target="_blank">
                                            {row.loc_city}
                                        </Link>
                                    </TableCell>
                                    <TableCell>{row.address}</TableCell>
                                    <TableCell align="center">
                                        {
                                            row.is_board_available ? (
                                                <Chip
                                                    label="Yes"
                                                    size="medium"
                                                    sx={{
                                                        background:
                                                            theme.palette.mode === 'dark'
                                                                ? theme.palette.dark.main
                                                                : theme.palette.success.light + 60,
                                                        color: theme.palette.success.dark
                                                    }}
                                                />
                                            ) : (
                                                <Chip
                                                    label="No"
                                                    size="medium"
                                                    sx={{
                                                        background:
                                                            theme.palette.mode === 'dark'
                                                                ? theme.palette.dark.main
                                                                : theme.palette.error.light + 60,
                                                        color: theme.palette.error.dark
                                                    }}
                                                />
                                            )
                                        }
                                    </TableCell>
                                    <TableCell>
                                        {
                                            row.published ? (
                                                <Chip
                                                    label="Published"
                                                    size="medium"
                                                    sx={{
                                                        background:
                                                            theme.palette.mode === 'dark'
                                                                ? theme.palette.dark.main
                                                                : theme.palette.success.light + 60,
                                                        color: theme.palette.success.dark
                                                    }}
                                                />
                                            ) : (
                                                <Chip
                                                    label="Incomplete"
                                                    size="medium"
                                                    sx={{
                                                        background:
                                                            theme.palette.mode === 'dark'
                                                                ? theme.palette.dark.main
                                                                : theme.palette.error.light + 60,
                                                        color: theme.palette.error.dark
                                                    }}
                                                />
                                            )
                                        }
                                    </TableCell>
                                    <TableCell>
                                        <ColoredDropdown
                                            itemArray={USER_STATUS}
                                            selectedValue={row.is_active}
                                            rowUuid={row.uuid}
                                            handleChange={changeStatus}
                                        />
                                    </TableCell>
                                    <TableCell align="center" sx={{ pr: 3 }}>
                                        <Stack direction="row" justifyContent="center" alignItems="center">
                                            <Tooltip placement="top" title="Edit">
                                                <IconButton
                                                    color="primary"
                                                    aria-label="delete"
                                                    size="large"
                                                    onClick={() => handleEditVenue(row.uuid)}
                                                >
                                                    <EditIcon sx={{ fontSize: '1.1rem' }} />
                                                </IconButton>
                                            </Tooltip>
                                            <DeleteAlert setReload={setReload} venueUuid={row.uuid} />
                                        </Stack>
                                    </TableCell>
                                </TableRow>
                            )
                        })
                    }
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default VenueList;
